import { createFileRoute } from '@tanstack/react-router'
import Header from '@/components/layouts/Header'
import Footer from '@/components/layouts/Footer'
import LandingHero from '@/components/sections/LandingHero'
import PerformanceShowcase from '@/components/sections/PerformanceShowcase'
import AllocationShowcase from '@/components/sections/AllocationShowcase'
import ScreenerShowcase from '@/components/sections/ScreenerShowcase'
import WatchlistShowcase from '@/components/sections/WatchlistShowcase'
import FinancialsShowcase from '@/components/sections/FinancialsShowcase'

export const Route = createFileRoute('/')({
  component: LandingPage,
})

function LandingPage() {
  return (
    <div className="flex flex-col min-h-screen w-full bg-background text-foreground overflow-x-hidden">
      <Header />
      <main className="flex-1 w-full">
        {/* Hero with CTA */}
        <LandingHero />

        {/* Feature Showcases */}
        <PerformanceShowcase />
        <AllocationShowcase />
        <ScreenerShowcase />
        <FinancialsShowcase />
        <WatchlistShowcase />
      </main>
      <Footer />
    </div>
  )
}
